(() => {
  if (window.kmCartAiFeeCleanup) return;
  window.kmCartAiFeeCleanup = true;
  let running = false;
  let pending = false;
  const isFee = item => item.properties?._customizer_ai_fee === 'true' || item.handle === 'ai-artwork-preparation';
  const associated = (fee, item) => {
    if (isFee(item)) return false;
    const f = fee.properties || {};
    const p = item.properties || {};
    return f._customizer_design_id
      ? f._customizer_design_id === p._customizer_design_id
      : Boolean(f._customizer_edit_token && f._customizer_edit_token === p._customizer_edit_token);
  };
  async function reconcile() {
    if (running) { pending = true; return; }
    running = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      const updates = {};
      for (const fee of cart.items || []) {
        if (isFee(fee) && !cart.items.some(item => associated(fee, item))) updates[fee.key] = 0;
      }
      if (!Object.keys(updates).length) return;
      const result = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (result.ok) window.location.reload();
    } catch (error) {
      // Server-rendered orphan fee removal remains available if cleanup fails.
      console.warn('Unable to remove orphaned AI artwork fee', error);
    } finally {
      running = false;
      if (pending) { pending = false; reconcile(); }
    }
  }
  document.addEventListener('shopify:cart:lines-update', event => {
    const completion = event.detail?.promise || event.promise;
    if (completion?.then) completion.then(reconcile, () => {});
    else setTimeout(reconcile, 500);
  });
  reconcile();
})();
